import { useEffect, useState } from 'react';
import { useProgress } from '@react-three/drei';
import './style.css';

function ProgressBarLoader() {
  const { progress } = useProgress();
  const [showProgressBar, setShowProgressBar] = useState(true);

  useEffect(() => {
    if (progress >= 100) {
      setTimeout(() => {
        setShowProgressBar(false);
      }, 10000); // Adjust the timing here (in milliseconds)
    }
  }, [progress]);

  return showProgressBar ? (
    <div className={`Loading-screen ${progress >= 100 ? 'fade-out' : ''}`}>
      <div className='bck'></div>
      <div>
        <h1 className='LoadingTitle'>National Library of Kosovo</h1>
        <h2 className='LoadingTitle2'>Made By DrinLajci</h2>
        <h2 className='progress'>{progress} %</h2>
      </div>
    </div>
  ) : null;
}

export default ProgressBarLoader;
